export const buildQueryParams = (
  base: Record<string, string | number | undefined>,
  multi?: Record<string, string[] | undefined>,
): string => {
  const params = new URLSearchParams();

  for (const [key, value] of Object.entries(base)) {
    if (value !== undefined && value !== '') {
      params.append(key, String(value));
    }
  }

  for (const [key, values] of Object.entries(multi ?? {})) {
    values?.forEach((v) => params.append(key, v));
  }

  return params.toString();
};
